export default __webpack_public_path__ + "static/selo_perto_digital-b9aacffc4f8833622ee31a0a5369422d.png";